import React, { Component, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { fetchComponents, fetchEmployeePayrolls, seletcEmployeePayroll, selectTenantComponents, fetchBenefits, selectTenantBenfits, resetEmployeePayrollData } from "../../Redux/Slices/ProcessPayrollSlice";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import { parseColumnConfig, parseColumnConfigContractorProcessPayrun, parseVisibleColumnConfig, PayrollColumnConfigForProcessPayroll } from "../configs/config";
import Utility, { deepClone } from "../../utility/Utility";
import PayrollService from "../../services/PayrollService";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import Table from "../../services/table";
import { CONSTANTS, INITIAL_PAYROLL_FILTERS } from "../../constants/Constant";
import { showLoader, removeLoader, showAlert, showToast, TOAST_TYPE, DKIcons } from 'deskera-ui-library';
import { PayrollManager } from "../../../src/managers/PayrollManager"
import { showUpdatePayrollPopup } from "../../SharedComponents/EditPayrollPopUp";
import SegmentListContainer from "../list/SegmentListContainer";
import { getTenantCountryCode, isIndiaCompliance, isUSCompliance, showAccessDeniedAlert } from "../../managers/common/CommonUtil";
import { getExportDataFile } from "../import_export/utility/ExportData";
import { supportedFileTypes } from "../import_export/EximConstants";
import PaymentMethod from "./PaymentMethod";
import TenantManager from "../../managers/TenantManager";
import debounce from "../../utility/Debounce";
import { COUNTRY } from "../../constants/CountryConstant";
import { fetchBankDetails } from "../../Redux/Slices/EmployeeListSlice";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import { isMobileWebView } from "../../utility/ViewportSizeUtils";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";



const ProcessPayrollGrid = (props) => {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: {},
        filter: {}
    };

    const payrunId = props.payrunId ? props.payrunId : CONSTANTS.EMPTY_STRING;
    const isContractor = props.isContractor ? props.isContractor : false;
    const module = isContractor ? MODULE.CONTRACTOR_PAYRUN : MODULE.PAYRUN;
    const [employeePayrolls, setEmployeePayrolls] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    const [showList, setFiltersList] = useState(true);
    const [payScheduleName, setPayScheduleName] = useState(CONSTANTS.EMPTY_STRING);
    const isActionEnabled = props.isAction;
    const isActionColumnEnabled = true;
    const [reload, setReload] = useState(false);
    const [payrollFilters, setPayrollFilters] = useState(INITIAL_PAYROLL_FILTERS);
    const [initialValue, setFilterInitialValue] = useState(0);
    const [invalidUnpaidDays, setInvalidUnpaidDays]= useState([]);
    const [exportButtonName, setExportButtonName] = useState("Export Payrun");
    const [paymentMethodPopup, setPaymentMethodPopup] = useState({
      visible:false,
      data:null,
      payrunId: null
    });
    const [negativeUnpaidDays, setNegativeUnpaidDays]= useState([]);
    const [searchStringValue, setSearchStringValue] = useState(CONSTANTS.EMPTY_STRING);
    const [searchStringValueCheck, setSearchStringValueCheck] = useState(false);
    const [isLoadPayrollData, setLoadPayrollData] = useState(false);
    const dispatch = useDispatch();

    const employeePayrollsData = useSelector(seletcEmployeePayroll)
    
    

    const componentsData = useSelector(selectTenantComponents)

    const benefitsData = useSelector(selectTenantBenfits)

    const gridButtons = (!isMobileWebView() && PermissionUtils.hasAccess(module,[ACTION.EXPORT])) ? [
      {
        title: "Export",
        className: "bg-app text-white",
        onClick: () => onPayrunStageExport(),
        icon: DKIcons.white.ic_export,
        // icon: DKIcons.ic_export,
      },
    ]:[];
    useEffect(() => {
        RouteManager.setPresenter({ props });
        return () => {
            setEmployeePayrolls(initialState);
            dispatch(resetEmployeePayrollData());
        }
    }, [])

    useEffect(() => {
        if (!Utility.isEmpty(employeePayrollsData)) {
            const { payruns, filterResponse } = employeePayrollsData;
            if (
              initialValue === 0 &&
              payrunId === employeePayrollsData?._id &&
              !employeePayrollsData?.payrolls && !searchStringValueCheck
            ) {
              deletePayrunWithNoPayrolls();
            }
            const isEditEnable = isActionEnabled && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) && PermissionUtils.hasAccess(module, [ACTION.EDIT]);
            const {rowData, incompleteProfiles, isFixedAllowanceNegative} = PayrollColumnConfigForProcessPayroll(employeePayrollsData, isEditEnable, isContractor);
            let processPayrollColumn;
            if(!isContractor) {
                processPayrollColumn = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PAYROLL_PROCESS), TABLES.PAYROLL_PROCESS));
            } else {
                let columns = parseColumnConfigContractorProcessPayrun (
                  deepClone(
                    TableManger.getTableVisibleColumns(TABLES.PAYROLL_PROCESS)
                  )
                );
                processPayrollColumn = parseVisibleColumnConfig(columns);
            }
            const passingData = {
                columnData: deepClone(processPayrollColumn),
                rowData,
                filter: [],
                originalData: employeePayrollsData
            };
            const isFilterListEnabled = employeePayrollsData.length > 0 ? true : false;
            updatePayrunFilters();
            setPayrollFilters(payrollFilters);
            setEmployeePayrolls(passingData);
            setTotalPageCount(employeePayrollsData.filter ? employeePayrollsData.filter.totalPages : 1);
            setCurrentPage(employeePayrollsData.filter ? employeePayrollsData.filter.currentPage : 1);
            setTotalCount(employeePayrollsData.filter ? employeePayrollsData.filter.totalCount : 0)
            setFiltersList(isFilterListEnabled);
            setPayScheduleName(employeePayrollsData.paySchedule ? employeePayrollsData.paySchedule.name : "")
            document.addEventListener("change", onOtChanged);
            document.addEventListener("click", onClickPaymentMethod)
            loadTenantComponents(PayrollService.apiConfig)
            loadTenantBenefits(PayrollService.apiConfig)
            if (getTenantCountryCode() === COUNTRY.SG || getTenantCountryCode() === COUNTRY.MY ) {
                loadTenantBankDetails(getTenantCountryCode());
              }
            props.setData({
              isInvalid: employeePayrollsData.isValid ? [] : [true],
              invalidProfiles: incompleteProfiles,
              invalidUnpaidDays: [],
              negativeUnpaidDays: [],
              isFixedAllowanceNegative: isFixedAllowanceNegative
            });
            dispatchEvent(new CustomEvent('processDataUpdated', { detail: { payrollData: employeePayrollsData } }));

        }
        return () => {
            document.removeEventListener("change", onOtChanged)
            document.removeEventListener("click", onClickPaymentMethod)
        }
    }, [employeePayrollsData, reload]);

    useEffect(() => {
      if (!Utility.isEmpty(payrunId)) {
        let searchString = getPaymentMethodKey(initialValue);
        let config = PayrollService.apiConfig;
        config = {
          ...config,
          Limit: 20,
          CurrentPage: 1,
          Order: "desc",
          Field: "_id",
          SearchField: "firstName",
          SearchString: searchStringValue,
          PaymentMethod: getPaymentMethod()

        };
        loadPayrollForFirstStep(config);
      }
    }, [payrunId, initialValue]);

    const onFilter = (updatedList, queries) => {

    }

    const getPaymentMethodKey = (initialValue) => {
        let searchString = "";
        let selectedFilter = payrollFilters.find(
          (filter) => filter.id === initialValue
        );
        if (selectedFilter) {
          searchString = selectedFilter.key;
        }
        return searchString;
    };

    const onFilterSelect = (segment) => {
      setFilterInitialValue(segment.id);
    };

    const updatePayrunFilters = () => {
        if (isIndiaCompliance()) {
              let addtionalFilters = [{ id: 4, name: "UPI", key: "upi" }];
              addtionalFilters.forEach((element) => {
                let index = payrollFilters.findIndex(
                  (x) => x.id === element.id
                );
                if (index === -1) {
                  payrollFilters.push(element);
                }
              });
            } else if(isUSCompliance()) {
                let chequeFilter = payrollFilters.find(x => x.name === CONSTANTS.CHEQUE);
                if (chequeFilter) chequeFilter.name = CONSTANTS.CHECK;
            }
    }

    const ifProcessedPayrollEmpty = (deletedId) => {
        if (employeePayrollsData && employeePayrollsData.payrolls && employeePayrollsData.payrolls.length == 1) {
            RouteManager.navigateToPage(PAGE_ROUTES.PAYROLL_GRID);
        }
    }
    const onClickPaymentMethod = (e) => {
      if(e && e.srcElement.id &&  e.srcElement.id.includes("payment_method_")) {
        let elementId = e.srcElement.id;
        elementId = elementId.substring(15,elementId.length)
        const payrollClone = deepClone(employeePayrollsData);
        let ind = payrollClone?.payrolls?.findIndex(p=>p._id==elementId);
        if( ind != -1 && props.state.currentStep === 0) {

          setPaymentMethodPopup({
            visible:true,
            data: payrollClone.payrolls[ind],
            payrunId:props.payrunId
          })
        }
      }
    }
    const onOtChanged = (e) => {
        const elementIds = PayrollManager.otIds;
        const lopElementIds = PayrollManager.lopIds;
        if(!isContractor && elementIds.some((id) => id === e.srcElement.id)) {
              let isUpdated = true;
              let overTime1 = {
                amount: 0,
                rate: 1.5,
                value: 0,
              };
              let overTime2 = {
                amount: 0,
                rate: 2.0,
                value: 0,
              };

              const changedValue = Number(
                document.getElementById(e.srcElement.id).value
              );
              const splitId = e.srcElement.id.split("_");
              const index =
                splitId[0] && splitId[0] !== CONSTANTS.EMPTY_STRING
                  ? Number(splitId[0])
                  : 0;
              let payroll = employeePayrollsData.payrolls.find(
                (payroll) => payroll._id === splitId[2]
              );

              let overtimes = [];
              if (payroll.overtime && payroll.overtime.length > 0) {
                payroll.overtime.forEach(ot=>{
                  overtimes.push(deepClone(ot));
                })          
              }
              if(overtimes.length == 0 ) {
                if(payroll.overtime && payroll.overtime.length !=0 && payroll.overtime[0]) {
                  overTime1 = deepClone(payroll.overtime[0]);
                  if(payroll.overtime[1]) {
                    overTime2 = deepClone(payroll.overtime[1]);
                  }
                }
                overtimes.push(overTime1);
                overtimes.push(overTime2); 
              } 

              const payrollClone = deepClone(payroll);
              const hourlyPay = payroll && (payroll.otPayRate ? payroll.otPayRate : ((payroll.hourlyPay ? payroll.hourlyPay : 0)))  ;
              switch (splitId[1]) {
                case "rate":
                  overtimes[index].rate = changedValue;
                  overtimes[index].amount =
                    changedValue * overtimes[index].value * hourlyPay;
                  break;
                case "value":
                  overtimes[index]["value"] = changedValue;
                  overtimes[index].amount =
                    changedValue * overtimes[index].rate * hourlyPay;
                  break;
                default:
              }
              payrollClone["overtime"] = overtimes;
              updatePayrollOvertime(payrollClone, employeePayrollsData._id);
        } else if(!isContractor && lopElementIds.some((id) => id === e.srcElement.id)) {
            let paramter = {};
            const changedValue = Number(
              document.getElementById(e.srcElement.id).value
            );
            const splitId = e.srcElement.id.split("_");

            const componentsTemp = (componentsData && componentsData.components) ?componentsData.components:[];
            const componentMap = {};
            componentsTemp.forEach((val)=>{
              componentMap[val.id]= val.isUnpaidIncluded;
            });
            const employeePayrollsDataPayrolls = (employeePayrollsData && employeePayrollsData.payrolls)?deepClone(employeePayrollsData.payrolls):[];
            employeePayrollsDataPayrolls.forEach((payroll)=>{
              const component = (payroll && payroll.components)?payroll.components:[];
              component.forEach((item)=>{
                if(componentMap.hasOwnProperty(item.componentId)){
                  item.isUnpaidIncluded = componentMap[item.componentId];
                }
              })
            });
            let payroll = employeePayrollsDataPayrolls.find(
              (payroll) => payroll._id === splitId[1]
            );
            if (employeePayrollsData.companyDaysBetweenPeriod < changedValue) {
              invalidUnpaidDays.push(payroll._id);
              const payrunCalcCriteria = TenantManager.getPeopleTenantData()?.tenant?.payrunCalcCriteria;
              let errMsg =
              `Unpaid Days should not be more than ${payrunCalcCriteria === 'numberOfCalendarDaysInMonth' ? "calendar days." : "work period."}`;              showToast(errMsg, TOAST_TYPE.FAILURE);
              props.setData({
                invalidUnpaidDays: invalidUnpaidDays,
              });
              return;
            }
            if (changedValue < 0) {
              negativeUnpaidDays.push(payroll._id);
              let errMsg = "Unpaid Days should not be less than 0.";
              showToast(errMsg, TOAST_TYPE.FAILURE);
              props.setData({
                negativeUnpaidDays: negativeUnpaidDays,
              });
              return;
            }
            if (invalidUnpaidDays && invalidUnpaidDays.length > 0) {
              let index = invalidUnpaidDays.findIndex((x) => x === payroll._id);
              if (index != -1) {
                invalidUnpaidDays.splice(index, 1);
                props.setData({
                  invalidUnpaidDays: invalidUnpaidDays,
                });
              }
            }
            if (negativeUnpaidDays && negativeUnpaidDays.length > 0) {
              let index = negativeUnpaidDays.findIndex(
                (x) => x === payroll._id
              );
              if (index != -1) {
                negativeUnpaidDays.splice(index, 1);
                props.setData({
                  negativeUnpaidDays: negativeUnpaidDays,
                });
              }
            }
            const payrollClone = deepClone(payroll);
            payrollClone["daysOff"] = changedValue;
            payrollClone["lossOfPay"] = changedValue * payrollClone.basicPayForDay;
            updatePayrollOvertime(payrollClone, employeePayrollsData._id);

        } else if(isContractor) {
            const elementIds = PayrollManager.rhIds;
            if (elementIds.some((id) => id === e.srcElement.id)) {
                const changedValue = Number(document.getElementById(e.srcElement.id).value);
                const splitId = e.srcElement.id.split("_");

                const payroll = employeePayrollsData.payrolls.find(
                  (payroll) => payroll._id === splitId[1]
                );

                const payrollClone = {
                    ...deepClone(payroll),
                    ...getWorkingHoursObject(payroll, changedValue)
                };

                updatePayrollOvertime(payrollClone, employeePayrollsData._id);
            }
        }
    }

    const getWorkingHoursObject = (payroll, value) => {
        const object = {
          compensationCurrency: payroll.compensationCurrency,
          compensationPeriod: payroll.compensationPeriod,
          components: payroll.components ? payroll.components : [],
          employeeId: payroll.employeeId,
          firstName: payroll.firstName,
          hoursWorked: value,
          lastName: payroll.lastName,
          _id: payroll._id,
        };

        return object;
    }

    const updatePayrollOvertime = (payroll, payrunId) => {

        showLoader("Updating value...")
        Table.upatePayroll(payroll, payrunId).then((data) => {
            showToast("Record updated Successfully", TOAST_TYPE.SUCCESS);
            removeLoader()
            loadPayrollForFirstStep(PayrollService.config)
        })
    }


    const onDeletePayroll = (data) => {
        let payrollIds = []
        let params = {}
        let payrunId = ""
        if(data && data.rowData && data[0]) {
            payrunId = data[0].payrunId
            payrollIds = [data.rowData.id]
            params = {
                'ids': payrollIds
            }
        } else if(data.length>0){
            payrunId = data[0].payrunId
            data.forEach(payroll => {
                payrollIds.push(payroll.id)
             })
             params = {
                'ids': payrollIds
            }
         } else if(data && data.rowData && data.rowData.payrunId) {
            payrunId = data.rowData.payrunId
            payrollIds = [data.rowData.id]
            params = {
                'ids': payrollIds
            }
         }
        showLoader(`Payroll is being deleted...`);
        (Table.deletePayrollMapping(params,  payrunId)
        ).finally(() => removeLoader())
            .then(
                (res) => {
                    showToast(
                        `Payroll deleted.`,
                        TOAST_TYPE.SUCCESS
                    );
                    ifProcessedPayrollEmpty()
                    loadPayrollForFirstStep(PayrollService.config)
                },
                (err) => {
                    showToast(
                        "Some Unknown Error Occurred at Server.Please Try Again!",
                        TOAST_TYPE.FAILURE
                    );
                }
            );

    }


    const loadPayrollForFirstStep = async (config) => {
        try {
            showLoader()
            PayrollService.apiConfig = config;
            await dispatch(fetchEmployeePayrolls(payrunId));
            setLoadPayrollData(true)
            removeLoader()
        } catch (err) {
            setLoadPayrollData(true)  
            removeLoader()

            console.error('Error loading payrolls: ', err);
        }
    };

    const loadTenantComponents = async (config) => {
        try {
            PayrollService.apiConfig = config;
            await dispatch(fetchComponents());
            // console.log("Data loaded")
        } catch (err) {
            console.error('Error loading payrolls: ', err);
        }
    };

    const loadTenantBenefits = async (config) => {
        try {
            PayrollService.apiConfig = config;
            await dispatch(fetchBenefits());
            // console.log("Data loaded")
        } catch (err) {
            console.error('Error loading payrolls: ', err);
        }
    };

    const loadTenantBankDetails = async (countryCode) => {
        try {
          await dispatch(fetchBankDetails(countryCode));
        } catch (err) {
          console.error("Error loading custom fields data: ", err);
        }
    }

    const onRowEdit = (row = {}) => {

        let payroll = employeePayrollsData.payrolls.find(payroll => payroll._id === row.rowData.id)

        // console.log("dtat...", componentsData)
        // console.log("bene...", benefitsData)

        showUpdatePayrollPopup(
            {
                tableName: "people_update_payroll",
                displayName: "Payrun",
                recordId: row ? row.id : "",
                defaultValues: "",
                isCustomForm: true,
                inputData: { data: payroll, processPayrollDispatch: dispatch, tenantComponents: componentsData, tenantBenefits: benefitsData, payrunId : payrunId, fun: loadPayrollForFirstStep, totCompanyDays :  employeePayrollsData.companyDaysBetweenPeriod, isContractor: isContractor,employeePayrollsData:employeePayrollsData}
            })
    }

    const onContextCancel = () => {
        setReload(!reload)
    }

    const onColumnUpdate = (data) => {
      let { columnData } = data;
      Table.updateColumnPeople(
        columnData,
        TableManger.getTableId(TABLES.PAYROLL_PROCESS)
      ).then((data) => {
        getColumns();
      });
    };
    const onSort = (data) => {
      
      let config = PayrollService.apiConfig;
      config = {
        ...config,
        Limit: 20,
        CurrentPage: (config&&config.CurrentPage) ? config.CurrentPage :1,
        Order: data.order.toLowerCase(),
        Field: data.columnData.columnCode,
        PaymentMethod: getPaymentMethod()
      };
      loadPayrollForFirstStep(config);
    }

    const getColumns = () => {
      Table.getTable(TableManger.getTableId(TABLES.PAYROLL_PROCESS)).then(
        (data) => {
          TableManger.setTableColumns(data, TABLES.PAYROLL_PROCESS);
          // loadPayrollForFirstStep(PayrollService.config);
        },
        (err) => {}
      );
    };

    const onPayrunStageExport = () => {
      let payload = {
        ids: [payrunId]
      }
      exportPayrun(payload)
    }

    const exportPayrun = (data) => {
      const queryParams = {
        format: "XLSX",
        countryCode: TenantService.get(TENANT.COUNTRY_CODE),
        timezoneOffset: new Date().getTimezoneOffset() * -1,
        isContractor: isContractor
      };
      const options = {
        endPointOptions: null,
        fileName: "Payrun",
        fileType: supportedFileTypes["XLSX"],
      };
      showLoader("Exporting...Please wait");
      getExportDataFile(queryParams, data, options, "EXPORT_PAYRUN")
        .then((res) => {
          removeLoader();
          showToast("Payrun exported Successfully", TOAST_TYPE.SUCCESS);
        })
        .catch((error) => {
          removeLoader();
          showToast("Internal server error", TOAST_TYPE.ERROR);
        });
    };

    const deletePayrunWithNoPayrolls = () => {
      showLoader("Loading... Please wait")
      let params = [];
      params.push({
        payrunId: payrunId,
      });
      Table.deletePayroll(params).then((data) => {
        routeTopage();
      }, error => {
        routeTopage();
      });
    }

    const routeTopage = () => {
      if(!isContractor) {
        RouteManager.navigateToPage(PAGE_ROUTES.PAYROLL_GRID);
      } else {
        RouteManager.navigateToPage(PAGE_ROUTES.CONTRACTOR_PAYRUN_LIST);
      }
      
      showToast("No payrolls present in the payrun.", TOAST_TYPE.ERROR);
      removeLoader();
    }

    const onSearch = (searchTerm) => {

      if (searchStringValue.length === 0 && !searchTerm.replace(/\s/g, '').length) {
        return;
      }
      searchTerm = searchTerm.trim();
      setSearchStringValue(searchTerm);
      setSearchStringValueCheck(true);
      let config = PayrollService.apiConfig;
      config = {
        Order: "desc",
        Field: "_id",
        ...config,
        SearchField: "firstName",
        SearchString: searchTerm,
        CurrentPage:  1,
        Limit: 20,
        PaymentMethod: getPaymentMethod()
      };
      loadPayrollForFirstStep(config);
  };

  const onColumnShift = (newColumnArray) => {
    Table.shiftColumn(
        newColumnArray.map((column) => column.id),
        TableManger.getTableId(TABLES.PAYROLL_PROCESS)
      ).then((data) => {
        getColumns();
      });
  };

  const getPaymentMethod = () => {
    
    const payment_method = payrollFilters.find(payment=>payment.id === initialValue)
    return payment_method?payment_method.key:payrollFilters[0].key
  };
    return (
      <div className="column parent-width flex-1 parent-height">
        {!isContractor && (
          <SegmentListContainer
            data={payrollFilters}
            selectedId={initialValue}
            onChange={onFilterSelect}
            // onClickNew={this.showAddSegmentPopup}
            maxWidth={React.createRef().current?.innerWidth}
            isAddEnabled={false}
          />
        )}
        {paymentMethodPopup.visible && (
          <PaymentMethod
          data={paymentMethodPopup.data}
            payrunId={paymentMethodPopup.payrunId}
            onClose={(refresh) => {
              if(refresh) {
                loadPayrollForFirstStep()
              }
              setPaymentMethodPopup({
                visible: false,
                data: null,
                payrunId: null
              })
            }
            }
          />
        )}
        <div className="column parent-width mb-s position-relative flex-1 ">
          <DataGridHolderPayroll
            tableName={TABLES.PAYROLL_PROCESS}
            displayTableName={TABLE_DISPLAY_NAME[TABLES.PAYROLL_PROCESS]}
            allowRowEdit={false}
            allowColumnEdit={PermissionUtils.hasAccess(module, ACTION.EDIT)}
            allowColumnDelete={PermissionUtils.hasAccess(module, isContractor ? ACTION.DELETE : ACTION.EDIT)}
            onRowDelete={onDeletePayroll}
            onRowEdit={(data) => {
                if (PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT)) {
                    onRowEdit(data);
                } else {
                    showAccessDeniedAlert();
                }
            }}
            allowRowAdd={false}
            allowColumnAdd={false}
            allowColumnShift={false}
            allowSearch={true}
            allowFilter={false}
            onCancelContext={() => {
              onContextCancel();
            }}
            addButtonConfig={gridButtons}
            onPaginationClick={(requestedPageNumber) => {
              console.log(PayrollService.apiConfig,)
              const config = {
                Order: "desc",
                Field: "_id",
                ...PayrollService.apiConfig,
                CurrentPage: requestedPageNumber,
                Limit: 20,
                
                SearchField: "firstName",
                SearchString: searchStringValue,
                PaymentMethod: getPaymentMethod()
              };
              loadPayrollForFirstStep(config);
            }}
            allowDataExport={true}
            gridData={isLoadPayrollData ? employeePayrolls: initialState}
            onFilter={onFilter}
            filter={employeePayrolls.filter}
            currentPage={currentPage}
            totalPageCount={totalPageCount}
            isActionEnabled={isActionColumnEnabled}
            isMenuVisible={props.state.currentStep === 0}
            contextMenu={props.state.currentStep === 0}
            showContextEdit={false}
            onColumnUpdate={onColumnUpdate}
            onSearch={debounce(onSearch,500)}
            onSort={onSort}
            onColumnShift={onColumnShift}
            isActionColumnFirst={true}
            onColumnShift={(data)=> setReload(!reload)}
            module={module}
          />
        </div>
      </div>
    );

}

export default ProcessPayrollGrid